import * as yup from 'yup';

export const stationParameterWarningSchema = yup.object({
  stationId: yup.number().required('Đây là trường bắt buộc'),
  parameterId: yup.number().required('Đây là trường bắt buộc'),
  earlyWarningMin: yup
    .number().typeError('Nhập số')
    .required('Đây là trường bắt buộc'),
  earlyWarningMax: yup
    .number().typeError('Nhập số')
    .required('Đây là trường bắt buộc')
}).test(
  'min-less-than-max',
  'Giá trị tối thiểu phải nhỏ hơn giá trị tối đa',
  (obj) =>
    obj.earlyWarningMin === undefined || obj.earlyWarningMax === undefined ||
    obj.earlyWarningMin < obj.earlyWarningMax
);